import { motion } from 'motion/react';

export function SD({ current, total }) {
  return (
    <div className="mb-5 flex justify-center gap-2">
      {Array.from({length:total}).map((_,i) => (
        <motion.div
          key={i}
          className={`h-2.5 rounded-finley-full ${
            i + 1 <= current ? 'bg-finley-primary shadow-finley-sm' : 'bg-finley-text-muted/30'
          }`}
          animate={{ width: i + 1 === current ? 28 : 10 }}
          transition={{ type: 'spring', stiffness: 260, damping: 20 }}
        />
      ))}
    </div>
  );
}
